import { render, staticRenderFns } from "./TabelaMateriais.vue?vue&type=template&id=107c302d&"
import script from "./TabelaMateriais.vue?vue&type=script&lang=js&"
export * from "./TabelaMateriais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports